export default __webpack_public_path__ + "static/media/unified-icon.ba509bcc.svg";